// src/components/TermsAndConditions.js

import React from "react";
import './TermsAndConditions.css';  // Import the CSS file for styling
import Footer from "../Footer/Footer";
import NavBar from "../NavBar/NavBar";
import RunningHeader from "../RunningHeader/RunningHeader";

const TermsAndConditions = () => {
  return (
    <div>
    <NavBar/>
    <RunningHeader/>
    <div className="terms-and-conditions-container">
      <header className="terms-and-conditions-header">
        <h1>Terms and Conditions for Reporters</h1>
      </header>

      <section className="terms-and-conditions-content">
        <h2>Introduction</h2>
        <p>
          Today Local News ("TLN") is a news website that provides local news and information to its readers. These Terms and Conditions ("Terms") govern the relationship between TLN and its reporters ("Reporters").
        </p>

        <h2>Definitions</h2>
        <ul>
          <li><strong>"Content"</strong> means any text, images, videos, or other materials submitted by Reporters to TLN.</li>
          <li><strong>"Reporter"</strong> means an individual who submits Content to TLN for publication.</li>
          <li><strong>"TLN"</strong> means Today Local News, its affiliates, and its subsidiaries.</li>
        </ul>

        <h2>Reporter Obligations</h2>
        <ul>
          <li><strong>Accuracy and Truthfulness:</strong> Reporters shall ensure that all Content submitted to TLN is accurate, truthful, and not misleading.</li>
          <li><strong>Originality:</strong> Reporters shall ensure that all Content submitted to TLN is original and does not infringe on the intellectual property rights of any third party.</li>
          <li><strong>Compliance with Laws:</strong> Reporters shall comply with all applicable laws and regulations when submitting Content to TLN.</li>
          <li><strong>Confidentiality:</strong> Reporters shall maintain the confidentiality of all information and materials provided by TLN.</li>
        </ul>

        <h2>TLN Obligations</h2>
        <ul>
          <li><strong>Publication:</strong> TLN shall publish Content submitted by Reporters on its website, subject to editorial review and approval.</li>
          <li><strong>Payment:</strong> TLN shall pay Reporters for their Content in accordance with the payment terms outlined on the TLN website.</li>
          <li><strong>Credit:</strong> TLN shall give Reporters credit for their work on the TLN website.</li>
        </ul>

        <h2>Intellectual Property</h2>
        <ul>
          <li><strong>Copyright:</strong> Reporters retain the copyright to their Content, but grant TLN a non-exclusive license to publish and distribute their Content on the TLN website.</li>
          <li><strong>Trademarks:</strong> TLN retains all rights to its trademarks, logos, and brand identities.</li>
        </ul>

        <h2>Termination</h2>
        <ul>
          <li><strong>Termination by TLN:</strong> TLN may terminate this Agreement and remove any Content submitted by Reporters at any time, without notice or liability.</li>
          <li><strong>Termination by Reporter:</strong> Reporters may terminate this Agreement and request removal of their Content from the TLN website at any time, without notice or liability.</li>
        </ul>
      </section>

      <footer className="terms-and-conditions-footer">
        <p>&copy; 2024 Today Local News. All Rights Reserved.</p>
      </footer>
    </div>
    <Footer/>
    </div>
  );
};

export default TermsAndConditions;
